import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import {useState} from "react";
import {Col} from "react-bootstrap";

export default function DeadlineSelection({onChange, selectedDeadline}) {
    // The first commit of Material-UI
    const [selectedDate, setSelectedDate] = useState( new Date());

    const handleDateChange = (date) => {
        onChange && onChange(date)
        setSelectedDate(date);
    };

    return (
        <Col className='col-auto'>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container>
                    <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        margin="normal"
                        label="Date limite"
                        value={selectedDate}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={handleDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </Grid>
            </MuiPickersUtilsProvider>
        </Col>
    )
}